/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-08 11:08:46
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-04 18:23:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/Options/Option/Value/Value.tsx
 */
import React from 'react';
import css from './css.less';

import classNames from 'classnames';
import ExpandInput from 'src/components/ExpandInput/ExpandInput';
import { WrappedTagsGroup } from 'src/components/TagGroup/TagGroup';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Value = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { tags, onPress, onDeleteValue, error, disabled } = props;

  const [input, setInput] = React.useState('');
  const onPressEnter = () => {
    if (onPress && input) onPress(input);
    setInput('');
  };
  return (
    <div className={classNames(css.container, { [css.error]: error })}>
      <WrappedTagsGroup
        containerClassName={css.containerClassName}
        tagClassName={css.tagClassName}
        closable={!disabled}
        onClose={onDeleteValue}
        tags={tags.map((i) => {
          return { name: i };
        })}
        suffixPart={
          !disabled && (
            <ExpandInput
              maxLength={50}
              size='small'
              fullyControlledFilter={(value) => value}
              containerClassName={css.inputContainer}
              placeholder={getI18n(
                'salesChannelProductDetail.index.pressentertoaddvalue',
              )}
              value={input}
              onChange={setInput}
              onPressEnter={onPressEnter}
            />
          )
        }
      />
    </div>
  );
};
export default Value;
